import { Cid } from "@/@types/esus/Cid";
import { esusApi } from "../api";

type CidsParams = {
	uf: string;
	ibgeCode: string;
	cnes: string;
	search: string;
};

export async function getCids({ uf, ibgeCode, ...cidsParams }: CidsParams) {
	const response = await esusApi.get<Cid[]>(`/uf/${uf}/city/${ibgeCode}/Cid/Get`, cidsParams);
	return response.data || [];
}
